module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/85b64e3c61fcd80ff1ee38fa30592aba.png";